/* file description */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Button, Drawer, Modal, Space } from 'antd';
// import { ifBtnShow } from '@/components/sp-centre/effect/useConfigBtn2Event';
import SpQiankun from '../sp-qiankun';
import styles from './index.module.less';
import { ButtonLayout, DrawerLayout } from '@/asset/AssetTask/templates/Cascade/components';
import RuleController from '../RuleController';
import { isEmpty } from 'lodash';
import { useButtonProps } from './effect/useButtonProps';
import { QiankunModalLayout } from './components/QiankunModalLayout';
import { isMobileEnv } from '@/utils';

export interface BtnInfoType {
  text?: string;
  cate?: string;
  position?: string;
  'position-direction'?: string;
  'position-module'?: string;
  freeJs?: string;
  taskId?: string;
}

export interface OptionParams {
  actionType: string; // 打开方式
  title: string;
  url: string; // 打开地址
  params?: Record<string, any>; // 参数
  width?: number;
}

export interface SpBusinessBtnType {
  btnInfo: BtnInfoType;
  btnsClick?: (value: { btnInfo: BtnInfoType; open: (val: OptionParams) => any; setButtonLoading: (val: boolean) => void }) => void;
  isRow?: boolean;
  openCallBack?: () => void;
  utils: any;
  record: any;
  moduleID: string;
  openDrawer?: boolean;
  isMobile?: boolean;
}

const SpBusinessBtn: React.FC<SpBusinessBtnType> = forwardRef((props, ref) => {
  const { btnInfo, record, moduleID, isMobile = isMobileEnv() } = props;
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hidePropsClickList = ['modal', 'router'];
  const [modalInfo, setModalInfo] = useState({
    title: '',
    type: '',
    width: undefined,
  });
  const [pageModalInfo, setPageModalInfo] = useState({
    routeUrl: '',
  });

  const options = useButtonProps(btnInfo);

  useImperativeHandle(ref, () => ({
    open,
  }));

  const open = (btnconfig: OptionParams) => {
    if (props?.openDrawer) {
      btnconfig.actionType = 'drawer';
    }
    let routeUrlInfo = btnconfig.url;
    const isShowTag = !routeUrlInfo?.includes('SHOWTYPE') && ['drawer', 'modal'].includes(btnconfig.actionType);
    if (btnconfig.params && !isEmpty(btnconfig.params)) {
      const tag = routeUrlInfo?.includes('?');
      try {
        routeUrlInfo += `${tag ? '&' : '?'}initParams=${JSON.stringify(btnconfig.params || {})}`;
        if (isShowTag) {
          routeUrlInfo += '&SHOWTYPE=modal';
        }
      } catch (e) {
        console.error(e);
      }
    } else if (isShowTag) {
      const tag = routeUrlInfo?.includes('?');
      routeUrlInfo += `${tag ? '&' : '?'}SHOWTYPE=modal`;
    }
    setModalInfo({
      title: btnconfig.title,
      type: btnconfig.actionType,
      width: btnconfig?.width,
    });
    if (['tab', 'spa'].includes(btnconfig.actionType)) {
      btnRouterPush({
        routerType: btnconfig.actionType,
        routerTabName: btnconfig.title,
        routerUrl: routeUrlInfo,
      });
      return;
    }

    if (['drawer', 'modal'].includes(btnconfig.actionType)) {
      setPageModalInfo({
        routeUrl: routeUrlInfo,
      });
      setIsModalOpen(true);
    }
  };

  const btnRouterPush = ({ routerType, routerTabName, routerUrl }: any) => {
    props.utils?.buiNavigate({
      type: routerType,
      path: routerUrl,
      title: routerTabName,
    });
  };
  const saveCb = (tag: boolean, result, values) => {
    if (tag) {
      props.utils?.reload && props.utils?.reload();
      props?.openCallBack && props.openCallBack(values);
      setIsModalOpen(false);
    }
  };

  return (
    <>
      <ButtonLayout
        className={!props?.isRow ? styles.btnStyle : ''}
        {...options}
        onClick={(e) => {
          if (!isMobile) {
            e?.stopPropagation();
          }
          props?.btnsClick && props.btnsClick({ btnInfo, open, setButtonLoading });
        }}
        loading={buttonLoading}
      >
        {btnInfo.text}
      </ButtonLayout>
      {/* <div onClick={(e) => e.stopPropagation()}> */}
      {
        modalInfo.type === 'modal' && (
          <QiankunModalLayout
            title={modalInfo.title}
            visible={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            width={modalInfo?.width || 800}
            footer={null}
            destroyOnClose
          >
            <SpQiankun
              saveCb={saveCb}
              qiankun={props.utils.qiankun}
              {...pageModalInfo}
            />
          </QiankunModalLayout>)
      }
      {
        modalInfo.type === 'drawer' && (
          <DrawerLayout
            title={modalInfo.title}
            placement="right"
            onClose={() =>
              setIsModalOpen(false)}
            visible={isModalOpen}
            contentWrapperStyle={{ minWidth: modalInfo?.width || '70%' }}
            destroyOnClose
            style={{
              overflow: 'hidden',
            }}
          >
            <SpQiankun
              saveCb={saveCb}
              qiankun={props.utils.qiankun}
              {...pageModalInfo}
            />
          </DrawerLayout>)
      }
      {/* </div> */}
    </>
  );
});

export default SpBusinessBtn;
